<template>
  <ion-button @click.stop="confirmAndDelete()">
    <ion-spinner
      v-if="busy"
      color="light"
    />
    <ion-icon
      v-else
      :src="i.trash"
    />
  </ion-button>
</template>

<script>
import router from '../../router'
import store from '../../state'


export default {
  data() {
    return {
      data: {},
      busy: false
    }
  },
  methods: {
    
  }
}
</script>